import { ILayoutElement } from "@faire/web-api/indigofair/data/ILayoutElement";
import { Spacer } from "@faire/web/slate/spacing";
import React from "react";
import styled from "styled-components";

import { LoggedOutCategoryPageLayoutElements } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageLayoutElements/LoggedOutCategoryPageLayoutElements";
import { useLoggedOutCategoryPageLayoutElementsIsLoading } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageLayoutElementsIsLoading";
import { HeaderPlaceholder } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/CategoryPageLoadingSkeleton/HeaderPlaceholder";

export const LoggedOutCategoryPageHeaderAndCarousel: React.FC = () => {
  const isLoading = useLoggedOutCategoryPageLayoutElementsIsLoading();
  if (isLoading) {
    return <HeaderPlaceholder />;
  }
  return (
    <Wrapper>
      <LoggedOutCategoryPageLayoutElements
        placement={[ILayoutElement.Placement.ABOVE_TITLE]}
      />
      <Spacer height="4x" />
      <LoggedOutCategoryPageLayoutElements
        placement={[ILayoutElement.Placement.BELOW_BREADCRUMB]}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
`;
